/**
 * ocx视频播放倍速字典表
 * key:页面显示倍速
 * value: ocx实际倍速参数
 */
const VIDEO_SPEED_DICT = {
    '1/32': 0.03125,
    '1/16': 0.0625,
    '1/8': 0.125,
    '1/4': 0.25,
    '1/2': 0.5,
    '1': 1.0,
    '2': 2.0,
    '4': 4.0,
    '8': 8.0,
    '16': 16.0
};
export default {
    methods: {
        // 控制工具栏操作
        controlHandle(type, speed) {
            switch (type) {
                // 全屏
                case 'fullScreen':                
                    // this.$refs.player.requestFullscreen();
                    this.requestFullscreen();
                    break;
                // 录像快退
                case 'videoFastBack':
                    this.speedHandle('videoFastBack', speed);                    
                    break;
                // 录像快进
                case 'videoFastGo':
                    this.speedHandle('videoFastGo', speed);
                    break;
                // 正常录像回放
                case 'playNormal':
                    this.$refs.OcxCom.ocxComObject.videoResume()
                    this.speedHandle('videoFastGo', '1');
                    break;
                // 恢复录像回放
                case 'videoResume':
                    this.$refs.OcxCom.ocxComObject.videoResume();                    
                    break;
                // 暂停录像回放
                case 'videoPause':
                    this.$refs.OcxCom.ocxComObject.videoPause();
                    break;
                // 停止录像回放
                case 'stopVideos':
                    this.$refs.OcxCom.ocxComObject.stopVideos();
                    break;
                // 本地抓拍路径
                case 'localSnapshotToDir':
                    // this.$refs.player.localSnap();
                    this.localSnap();
                    break;
                // 一键抓拍
                case 'localSnapList':
                    // this.$refs.player.localSnap();
                    this.localSnapList();
                    break;
                // 平台抓拍
                case 'platformSnapshot':
                    this.$refs.OcxCom.ocxComObject.platformSnapshot();
                    break;                    
                // 录像下载
                case 'videoDownload':
                    
                    break;
                /********* 实时浏览***************/
                // 播放实时画面
                case 'getLivePlay':
                    this.$refs.OcxCom.ocxComObject.getLivePlay();                    
                    break;
                // 停止实时画面
                case 'stopLivePlay':
                    this.$refs.OcxCom.ocxComObject.stopLivePlay();                  
                    break;
                // 开始录像
                case 'startRecord':
                    this.$refs.OcxCom.ocxComObject.startRecord();                    
                    break;
                // 停止录像
                case 'stopRecord':
                    this.$refs.OcxCom.ocxComObject.stopRecord();                  
                    break;
                /*********屏幕分割******************/
                // 一分屏
                case 'screen_1':
                    this.$refs.OcxCom.ocxComObject.setLayout(1);                    
                    break;
                // 四分屏
                case 'screen_4':
                    this.$refs.OcxCom.ocxComObject.setLayout(4);                  
                    break;
                // 九分屏
                case 'screen_9':
                    this.$refs.OcxCom.ocxComObject.setLayout(9);
                    break;
                default:
                    console.warn('工具栏失效')
                    break;
            }
        },
        // 分屏后切换码流 实时视频播放
        switchFlowToPlay(layout){
            this.$refs.OcxCom.ocxComObject.setLayout(layout);
            this.$refs.OcxCom.ocxComObject.getLivePlay();                      
        },
        // 倍速处理
        speedHandle(type="videoFastGo", speed='1') {            
            let _speed = type == "videoFastBack" ? -VIDEO_SPEED_DICT[speed] : VIDEO_SPEED_DICT[speed];
            this.$refs.OcxCom.ocxComObject[type](_speed);
        },
        // 开始下载录像
        downloadVideo(params,path) {
            this.$refs.OcxCom.ocxComObject.startDownload(params,path);
        },
        //隐藏ocxBar及Title 
        clearOcxBar(showTool, showTitle) {
            this.$refs.OcxCom.ocxComObject.clearOcxBar(0,0);
        },
        //显示ocxBar及Title
        showOcxBar(showTool, showTitle) {
            this.$refs.OcxCom.ocxComObject.showOcxBar(0,1);
        }
    }
}